<template>
  <div class="landing-intro">
    <section class="hero">
      <img :src="HeroImg" alt="Hero Image" />
    </section>
    <section class="start-action container">
      <p class="t1">長腳衣櫥 × TouchIn</p>
      <h2>
        智慧壓縮袋<br/>
        啟用說明
      </h2>
      <p class="t2">不用開袋，衣物清單一碰即現</p>
      <p class="t3">花 3 分鐘完成啟用，之後手機往袋上一碰，就能看見裡面裝了什麼，不用拆封、不用翻找。</p>
      <button class="t-black" @click="startBinding">開始啟用</button>
      <button class="t-white" @click="buyMore" v-if="!hideBuyButton">再買一個壓縮袋</button>
    </section>
    
    <section class="container py-4">
      <div class="instruction-div">
        <div class="row no-gutters">
          <div class="col-auto pr-3">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="white" stroke-width="2"/>
              <path d="M12 7.5V13" stroke="white" stroke-width="2" stroke-linecap="round"/>
              <path d="M12 17.75C12.6904 17.75 13.25 17.1904 13.25 16.5C13.25 15.8096 12.6904 15.25 12 15.25C11.3096 15.25 10.75 15.8096 10.75 16.5C10.75 17.1904 11.3096 17.75 12 17.75Z" fill="white"/>
            </svg>
          </div>
          <div class="col">
            <p class="mb-2">
              <span class="font-weight-bold">裝袋前，先做完啟用及拍照</span>
            </p>
            <p class="mb-0">
              衣物清單是在「入袋前」拍照建立的。等到壓縮封好才想記錄，就得整袋拆開重來一次。
            </p>
          </div>
        </div>
      </div>
    </section>
    
    <section class="steps">
      <div class="steps-head py-3 container">
        <h3 class="h2-title mb-2">
          簡單三步驟<br/>
          建立自己的收納系統
        </h3>
        <p class="text-desc">
          跟你平常收納的習慣一樣，只多了「拍照」和「碰一下」。
        </p>
      </div>
      <div class="steps-swiper">
        <flickity ref="stepsFlickity" class="steps-flickity" :options="stepsFlickityOpt">
          <div class="flickity-content">
            <div class="main-img">
              <img :src="Step1Img" alt="Step 1 Image" />
            </div>
            <div class="container py-3">
              <div class="step-intro">
                <div class="step-number">01</div>
                <div class="step-desc">
                  <p class="mb-2 h3-title">入袋前拍照</p>
                  <p class="text-desc">在衣物放進袋子前，用長腳衣櫥 App 拍照，為每件單品建立數位標籤。</p>
                </div>
              </div>
            </div>
          </div>

          <div class="flickity-content">
            <div class="main-img">
              <img :src="Step2Img" alt="Step 2 Image" />
            </div>
            <div class="container py-3">
              <div class="step-intro">
                <div class="step-number">02</div>
                <div class="step-desc">
                  <p class="mb-2 h3-title">壓縮密封</p>
                  <p class="text-desc">照你平常的方式摺好、擠出空氣、封緊袋口。</p>
                </div>
              </div>
            </div>
          </div>

          <div class="flickity-content">
            <div class="main-img">
              <img :src="Step3Img" alt="Step 3 Image" />
            </div>
            <div class="container py-3">
              <div class="step-intro">
                <div class="step-number">03</div>
                <div class="step-desc">
                  <p class="mb-2 h3-title">觸碰搜尋</p>
                  <p class="text-desc">手機靠近袋上的感應貼紙，袋子裡有什麼立刻顯示，不用拆封翻找。</p>
                </div>
              </div>
            </div>
          </div>
        </flickity>
      </div>
    </section>

    <section class="start-now">
      <div class="container py-5">
        <h3 class="h2-title mb-2">
          現在就啟用這個袋子
        </h3>
        <p class="text-desc mb-4">整個流程大約 3 分鐘，一次設定，之後每次碰一下就好。</p>
        
        <div class="d-flex align-items-center mb-2">
          <div class="mr-2">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#D07000"/>
              <path d="M8 12.3L10.7 15L16 9.69995" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div>
            登入或註冊長腳衣櫥帳號
          </div>
        </div>

        <div class="d-flex align-items-center mb-2">
          <div class="mr-2">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#D07000"/>
              <path d="M8 12.3L10.7 15L16 9.69995" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div>
            輸入袋口感應處旁的驗證碼
          </div>
        </div>

        <div class="d-flex align-items-center mb-2">
          <div class="mr-2">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#D07000"/>
              <path d="M8 12.3L10.7 15L16 9.69995" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div>
            綁定完成，300 織點立即入帳
          </div>
        </div>

        <p class="text-desc mb-4">
          ※ 本產品需搭配具備 NFC 功能之行動裝置使用。若手機不支援感應，也可以在 App 內手動輸入驗證碼綁定。
        </p>

        <div class="bg-white p-3" style="border-radius: .75rem;">
          <img :src="StickerImg" alt="Sticker" class="img-fluid"/>
          <p class="font-weight-bold mt-2 mb-2">
            驗證碼在哪裡？
          </p>
          <p class="text-desc">
            驗證碼就印在袋子上的感應處旁邊，是一組 6 碼英數字（例如 34R67D）。啟用時直接輸入即可。
          </p>
        </div>
      </div>
    </section>

    <section class="features">
      <div class="features-head">
        <h3 class="h2-title mb-3">
          壓縮袋只是開始<br/>
          長腳衣櫥還能做這些
        </h3>
        <p class="text-desc">
          袋子裡的每件衣服，同時也在你的線上衣櫥裡。拍一張照，AI 會自動去背、判斷分類與顏色。
        </p>
      </div>
      <div class="features-swiper">
        <flickity ref="featuresFlickity" class="features-flickity" :options="featuresFlickityOpt">
          <div class="flickity-content">
            <div class="main-img">
              <img :src="Feature1Img" alt="可視化衣櫥" />
            </div>
            <div class="feature-intro">
              <div class="feature-title-row">
                <icon name="icon-closet-border" size="24"></icon>
                <p class="mb-0 h3-title">可視化衣櫥</p>
              </div>
              <p class="text-desc">所有衣物一目了然，不用翻箱倒櫃</p>
            </div>
          </div>

          <div class="flickity-content">
            <div class="main-img">
              <img :src="Feature2Img" alt="穿搭紀錄" />
            </div>
            <div class="feature-intro">
              <div class="feature-title-row">
                <icon name="icon-outfit-border" size="24"></icon>
                <p class="mb-0 h3-title">穿搭紀錄</p>
              </div>
              <p class="text-desc">記下每天穿什麼，看見哪件常穿</p>
            </div>
          </div>

          <div class="flickity-content">
            <div class="main-img">
              <img :src="Feature3Img" alt="衣櫥數據" />
            </div>
            <div class="feature-intro">
              <div class="feature-title-row">
                <icon name="icon-data-border" size="24"></icon>
                <p class="mb-0 h3-title">衣櫥數據</p>
              </div>
              <p class="text-desc">買了多少、穿了幾次，數字會說話</p>
            </div>
          </div>

          <div class="flickity-content">
            <div class="main-img">
              <img :src="Feature4Img" alt="多袋管理" />
            </div>
            <div class="feature-intro">
              <div class="feature-title-row">
                <icon name="touchin" size="24"></icon>
                <p class="mb-0 h3-title">多袋管理</p>
              </div>
              <p class="text-desc">每個壓縮袋分開記錄，換季一次搞定</p>
            </div>
          </div>
        </flickity>

        <div class="container mt-5" v-if="!hideToWalkingClosetButton">
          <button class="t-black" @click="toWalkingcloset">前往長腳衣櫥</button>
        </div>

      </div>
    </section>

    <section class="cta py-4">
      <div class="container">
        <div class="row px-3">
          <div class="col-12 mb-3">
            <button class="text-center bg-g" @click="contactLine">
              <p class="font-weight-bold mb-0">聯絡我們</p>
              <p class="text-desc text-center">LINE 客服</p>
            </button>
          </div>
          <div class="col-12 mb-3">
            <button class="text-center bg-o" @click="buyMore">
              <p class="font-weight-bold mb-0">再買一個壓縮袋</p>
              <p class="text-desc text-center">好賣+ 賣場</p>
            </button>
          </div>

        </div>
      </div>
    </section>

    <section class="l-footer py-5">
      <div class="container">
        <p class="font-weight-bold mb-2 text-dark">長腳衣櫥 TouchIn</p>
        <p class="mb-4">
          TouchIn 智慧壓縮袋 70 × 100 cm 1 入裝<br/>
          型號 TI-CB-01 材質 複合尼龍聚乙烯 臺灣製造
        </p>
        <p>© 人人共創數位科技有限公司   02-7752-2510</p>
      </div>
    </section>
  </div>
</template>

<script>
import Flickity from 'vue-flickity';
import HeroImg from '@/assets/images/touchin/hero.png';
import Step1Img from '@/assets/images/touchin/step1.gif';
import Step2Img from '@/assets/images/touchin/step2.gif';
import Step3Img from '@/assets/images/touchin/step3.gif';
import StickerImg from '@/assets/images/touchin/sticker.png';
import Feature1Img from '@/assets/images/touchin/feature1.png';
import Feature2Img from '@/assets/images/touchin/feature2.png';
import Feature3Img from '@/assets/images/touchin/feature3.png';
import Feature4Img from '@/assets/images/touchin/feature4.png';

export default {
  name: 'LandingIntro',
  data() {
    return {
      HeroImg,
      Step1Img,
      Step2Img,
      Step3Img,
      StickerImg,
      Feature1Img,
      Feature2Img,
      Feature3Img,
      Feature4Img,
      stepsFlickityOpt: {
        wrapAround: false,
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        initialIndex: 0,
        autoPlay: false,
        // 圖片非同步載入完才重新計算 cell 尺寸，避免高度被裁切
        imagesLoaded: true,
        on: {
          ready: function () {
            this.resize();
          },
        },
      },
      featuresFlickityOpt: {
        wrapAround: false,
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        initialIndex: 0,
        autoPlay: false,
        imagesLoaded: true,
        on: {
          ready: function () {
            this.resize();
          },
        },
      },
    };
  },
  props: {
    showBuyLink: {
      type: Boolean,
      default: false,
    },
    hideBuyButton: {
      type: Boolean,
      default: false,
    },
    hideToWalkingClosetButton: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Flickity,
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.stepsFlickity) {
        this.$refs.stepsFlickity.resize();
      }
      if (this.$refs.featuresFlickity) {
        this.$refs.featuresFlickity.resize();
      }
    }, 500);
  },
  methods: {
    startBinding() {
      // 點下開始啟用，根據目前登入狀況判定要導到touch in綁定頁面，還是要先登入，或將這個工作交給登入頁來處理
      // this.$router.push({ name: 'TouchIn' });

      this.$emit('start-binding');
    },
    buyMore() {
      // 點下再買一個壓縮袋，導向好賣+ 賣場 網址 https://supr.link/crcDp
      window.open('https://supr.link/crcDp', '_blank');
    },
    contactLine() {
      // 聯絡Line客服
      window.open('https://line.me/R/ti/p/%40806asgyo', '_blank');
    },
    toWalkingcloset() {
      window.open('https://walkingcloset.network', '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

.hero {
  width: 100%;
  aspect-ratio: 750 / 562;
  background-color: var(--color-brand-primary);
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
button {
  border: none;
  padding: 0.75rem 1rem;
  width: 100%;
  border-radius: .75rem;
  &.t-black {
    background-color: #1B1B1B;
    color: #FFFFFF;
  }
  &.t-white {
    border: 1px solid #1B1B1B;
    background-color: transparent;
    color: #1B1B1B;
  }
}
.text-desc {
  color: #6F6F6F;
  font-size: 0.875rem;
  margin: 0;
}
.h3-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1B1B1B;
}
.h2-title {
  color: #1B1B1B;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}
.start-action {
  background-color: #FFFAF4;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: .75rem;
  * {
    margin: 0;
  }
  .t1 {
    font-size: 0.8rem;
    color: #D07000;
  }
  h2 {
    color: #1B1B1B;
    font-size: 2rem;
    font-weight: 600;
  }
  .t2 {
    font-size: 1rem;
    color: #1B1B1B;
    font-weight: 600;
  }
  .t3 {
    color: #6F6F6F;
  }
}
.instruction-div {
  background-color: #E96D45;
  border-radius: .75rem;
  color: #FFFFFF;
  padding: 1rem;
}
.steps {
  padding-bottom: 4rem;

  .steps-swiper {
    .steps-flickity {
      ::v-deep .flickity-content {
        width: 100%;
        .main-img {
          img {
            width: 100%;
            aspect-ratio: 375 / 274;
          }
        }
        .step-intro {
          padding: 0 .5rem;
          display: flex;
          flex-direction: row;
          gap: 1rem;
          .step-number {
            flex: 0 0 2rem;
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            background-color: #D07000;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      ::v-deep .flickity-page-dots {
        .dot {
          width: 4px;
          height: 4px;
          margin: 0 4px;
          border-radius: 50%;
          background: $color-border-main;
          opacity: 1;
          transition: width .2s ease, border-radius .2s ease, background-color .2s ease;

          &.is-selected {
            width: 36px;
            border-radius: 100px;
            background: $color-orange-soft;
          }
        }
      }
    }
  }
}

.features {
  // PDF @375: 側邊約 24、圖近正方形、圖下約 32、底部留 dots
  padding-bottom: 3.5rem;

  .features-head {
    padding: 2.75rem 1.5rem 1.5rem;

    .text-desc {
      margin: 0;
    }
  }

  .features-swiper {
    .features-flickity {
      ::v-deep .flickity-content {
        width: 100%;

        .main-img {
          padding: 0 1.5rem;

          img {
            display: block;
            width: 100%;
            height: auto;
            border-radius: 1rem;
          }
        }

        .feature-intro {
          padding: 2rem 1.5rem 0.75rem;

          .feature-title-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: .5rem;
            margin-bottom: .5rem;
          }

          .text-desc {
            margin: 0;
          }
        }
      }

      ::v-deep .flickity-page-dots {
        bottom: -1.75rem;

        .dot {
          width: 4px;
          height: 4px;
          margin: 0 4px;
          border-radius: 50%;
          background: $color-border-main;
          opacity: 1;
          transition: width .2s ease, border-radius .2s ease, background-color .2s ease;

          &.is-selected {
            width: 36px;
            border-radius: 100px;
            background: $color-orange-soft;
          }
        }
      }
    }
  }
}

.start-now {
  background-color: #B8E4E1;
}
.cta {
  button {
    &.bg-g {
      background-color: #B8E4E1;
    }
    &.bg-o {
      background-color: #F4CFA3;
    }
  }
}
.l-footer {
  background-color: #EEEEEE;
  color: #6F6F6F;
}
</style>
